import React from 'react';
import '../Css_files/Footer.css';
import img from "../Images/profenaa-org-logo1.png"
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Animated background elements */}
      <div className="footer-bg-animations">
        <div className="bg-circle circle-1"></div>
        <div className="bg-circle circle-2"></div>
        <div className="bg-circle circle-3"></div>
        <div className="bg-circle circle-4"></div>
      </div>

      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-brand">
          <div className="brand-logo-container">
            <div className="nav-logo-icon">
              <img src={img}></img>
             </div>
            <h1 className="brand-title">Profenaa Technologies</h1>
          </div>
          <p className="brand-description">
             Your trusted partner for high-quality education and comprehensive engineering training. Empowering future engineers with industry-relevant skills, expert guidance, and hands-on learning.
          </p>
          {/* <p className="copyright">
            <span className="heart">❤️</span>
            © 2018 Profenaa Technologies. All rights reserved.
          </p> */}

          {/* Social Media Icons */}
        
        </div>

        {/* Most Popular Posts */}
        <div className="footer-column">
          <h3 className="column-title">Quick Links</h3>
          <ul className="footer-list">
            <li><Link to="/mech"className="footer-link">Mechanical Courses</Link></li>
            <li><Link to="/civil" className="footer-link">Civil Courses</Link></li>
            <li><Link to="/ece" className="footer-link">Ece Courses</Link></li>
            <li><Link to="/electronics" className="footer-link">Electronics Courses</Link></li>
            <li><Link to="/computerscience"className="footer-link">Computer Science Courses</Link></li>
            <li><Link to="/ArtsMultimedia" className="footer-link">Arts & Multimedia Courses</Link></li>
          </ul>
        </div>

        {/* Learn More */}
        <div className="footer-column">
          <h3 className="column-title">Learn More</h3>
          <ul className="footer-list">
            <li><a href="https://forms.gle/EbDaNAqS6BYRNj4n8" className="footer-link">Enroll Now</a></li>
            <li><Link to="/about" className="footer-link">About Us</Link></li>
            <li><Link to="/career" className="footer-link">Careers</Link></li>
            <li><Link to="/blog" className="footer-link">Blog</Link></li>
            <li><Link href="/internship" className="footer-link">Internship</Link></li>
          </ul>
        </div>

        {/* Features */}
        <div className="footer-column">
          <h3 className="column-title">Terms and Policies</h3>
          <ul className="footer-list">
            <li><a href="#" className="footer-link">Terms & Conditions</a></li>
            <li><a href="#" className="footer-link">Refund Policy</a></li>
            <li><a href="#" className="footer-link">Privacy Policy</a></li>
            <li><a href="#" className="footer-link">Rescheduling Policy</a></li>
          </ul>
        </div>

        {/* Support */}
        <div className="footer-column">
          <h3 className="column-title">Contact Us</h3>
          <ul className="footer-list">
            <li><a href="#" className="footer-link"> 9944897638</a></li>
            <li><a href="#" className="footer-link">9698730528</a></li>
            <li><a href="#" className="footer-link">Profenaa.cbe@gmail.com</a></li>
          </ul>

          <h3 className="column-title">Address</h3>
          <ul className="footer-list">
            <li><a href="#" className="footer-link"> No 14 , First floor, Agni Amman Complex, Bus stand, Raja Mill Rd, backside, Pollachi, Tamil Nadu 642001</a></li>
          </ul>
               

           <h3 className="column-title">Social Media Links</h3>
<ul className="social-icons-row">
  <li>
    <a href="https://www.facebook.com/Profenaatechnologies/" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
      <i className="fab fa-facebook-f"></i>
    </a>
  </li>
  <li>
    <a href="https://www.instagram.com/profenaacoimbatore/?hl=en" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
      <i className="fab fa-instagram"></i>
    </a>
  </li>
  <li>
    <a href="https://wa.me/9944897638" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
      <i className="fab fa-whatsapp"></i>
    </a>
  </li>
  <li>
    <a href="https://in.linkedin.com/company/profenaa-technologies-pvtltd" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
      <i className="fab fa-linkedin-in"></i>
    </a>
  </li>
</ul>



 

        </div>

        
      </div>

      

      {/* Bottom Section - Privacy Policy and Terms */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          {/* <div className="footer-links">
            <a href="#" className="footer-bottom-link">Terms of Service</a>
            <a href="#" className="footer-bottom-link">Privacy Policy</a>
          </div> */}
          <div className="footer-copyright">
            © Profenaa Technologies. All rights reserved.
          </div>
        </div>
      </div>

      {/* Glowing bottom border */}
      <div className="footer-glow"></div>
    </footer>
  );
};

export default Footer;